import { render, staticRenderFns } from "./set03.vue?vue&type=template&id=d3a8d626&scoped=true&"
import script from "./set03.vue?vue&type=script&lang=js&"
export * from "./set03.vue?vue&type=script&lang=js&"
import style0 from "./set03.vue?vue&type=style&index=0&id=d3a8d626&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a8d626",
  null
  
)

export default component.exports